import { s as str } from './shared/pseudolocale.a1c1bbfb.mjs';



export { str as default };
